module.exports = __webpack_public_path__ + "img/success12.095e2d8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/success_img/success12.jpg
// module id = fDF5
// module chunks = 0